export default __webpack_public_path__ + "static/media/rat@3x.983202a6.png";